import _ from "lodash";
import {ModuleTree} from "@/util/RequireContextHelper";

class ServiceManager {
  private serviceClass: any = {};

  setService(moduleName: string, serviceName: string, tree: ModuleTree) {
    if (tree.dirs) {
      for (const [controllerName, sub] of Object.entries(tree.dirs)) {
        sub.files &&
          Object.values(sub.files).map((file) => {
            console.log("override /" + [serviceName, moduleName, controllerName, serviceName].join("/"))
            _.set(
                this.serviceClass,
                [serviceName, moduleName, controllerName],
                file.module.default
            )
          });
      }
    }
  }

  getService<T>(
    moduleName: string,
    controllerName: string,
    serviceName: string,
    defaultValue: T
  ): T {
    return _.get(
      this.serviceClass,
      [serviceName, moduleName, controllerName],
      defaultValue
    );
  }
}

export const serviceManager = new ServiceManager();
